import React, { useContext } from "react";
import { UserContext } from "@ipd/js-common";

type PermissionBoundaryProps = {
  allowedClaims: string[];
  renderNotAuthorized?: (allowedClaims: string[]) => JSX.Element | null | undefined;
};

const PermissionBoundary: React.FC<PermissionBoundaryProps> = ({
  allowedClaims,
  children,
  renderNotAuthorized = () => <h1>Not Authorized</h1>,
}) => {
  const { isLoggedIn, claims } = useContext(UserContext);

  if (!isLoggedIn) return null;
  if (!allowedClaims.some((p) => claims.includes(p))) return renderNotAuthorized(allowedClaims) ?? null;

  return <>{children}</>;
};

export default PermissionBoundary;
